import * as React from 'react';

import { AboutRealtorDesktop } from '../../components/AboutRealtorDesktop/AboutRealtorDesktop';

import { getRieltorDescription } from '../../components/AboutRealtorDesktop/helpers';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { IRealtorData } from '../../types/realtorInfo';
import { getDescriptionText, isLongDescription } from '../../utils/description';
import { getCounters } from '../../utils/counters';
import { getRatingSubtitle } from '../../utils/subtitle';

export interface IAboutRealtorDesktopContainerProps {
  realtorCardData: IRealtorData;
  realtor: ISpecialistCatalogListingSchema;
}

export function AboutRealtorDesktopContainer(props: IAboutRealtorDesktopContainerProps) {
  const { realtorCardData, realtor } = props;
  const { reviewsRate, reviewsCount } = realtor;
  const {
    agent: {
      age,
      name,
      avatarUrl,
      companyName,
      regionsNames,
      description,
      experience,
      skills,
      hasFairplay,
      isCianPartner,
      moderationInfo,
      hasRgrParticipation,
    },
    offers,
  } = realtorCardData;

  const [descriptionMinimized, setdescriptionMinimized] = React.useState(isLongDescription(description));
  const descriptionText = getDescriptionText(description, descriptionMinimized);
  const counters = getCounters({ experience, age, offers });
  const ratingSubtitle = getRatingSubtitle({ reviewsRate, reviewsCount });

  const handleDescriptionClick = React.useCallback(() => {
    setdescriptionMinimized(false);
  }, []);

  const about = getRieltorDescription({
    descriptionText,
    skills,
    regionsNames,
    companyName,
    onDescriptionOpen: descriptionMinimized ? handleDescriptionClick : undefined,
  });

  const aboutRealtorProps = {
    about,
    avatarUrl,
    counters,
    isAvatarRound: true,
    isCianPartner,
    hasFairplay,
    hasRgrParticipation: Boolean(hasRgrParticipation),
    name,
    rate: reviewsRate || 0,
    ratingSubtitle,
    moderationInfo: moderationInfo || null,
    userLevelInfo: moderationInfo?.userLevelInfo ?? undefined,
    onDescriptionClick: handleDescriptionClick,
  };

  return <AboutRealtorDesktop {...aboutRealtorProps} />;
}
